module.exports = __webpack_public_path__ + "static/media/txtbk_interac.61b7cad7.svg";